import { CompanySettings } from "./load-company-settings";

// Turn this on to get relative links for prod help centers
const LOCAL_TEST_MODE = false;
const hostnameRegex = /^(localhost|([a-zA-Z0-9-]+\.)*atls\.app)$/; // localhost OR *.atls.app

export default function getBaseUrl(settings: CompanySettings) {
  if (LOCAL_TEST_MODE && globalThis?.location?.hostname.match(hostnameRegex)) {
    return `${globalThis.location.origin}/${settings.slug}`;
  }

  const url = settings.customDomain
    ? settings.customDomain
    : `${settings.helpCenterUrl || ""}/${settings.slug}`;
  if (url.endsWith("/")) return url.slice(0, -1);
  return url;
}
